import { Grid } from '@mui/material';
import { GridSpacing } from '@mui/material/Grid/Grid';
import { FlexboxProps, GridProps } from '@mui/system';
import clsx from 'clsx';
import { isEmpty, map } from 'lodash';
import { ComponentType, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Annunciator } from '../annunciator';
import { Loader } from '../loader';

interface DataGridProps extends GridProps, FlexboxProps {
  data: any[];
  renderItem: (item: any, idx: number) => ReactNode;
  hiddenCondition?: (item: any) => boolean;
  className?: string;
  itemClassName?: string;
  itemProps?: { [key: string]: any };
  isLoading?: boolean;
  spacing?: GridSpacing;
}

export const DataGrid: ComponentType<DataGridProps> = ({
  data,
  renderItem,
  hiddenCondition,
  itemClassName,
  itemProps,
  isLoading = false,
  ...props
}) => {
  const { t } = useTranslation();

  const items = map(data, (item: any, idx: number) => (
    <Grid
      item
      {...itemProps}
      className={clsx(itemClassName)}
      key={idx}
      hidden={hiddenCondition && hiddenCondition(item)}
    >
      {renderItem(item, idx)}
    </Grid>
  ));

  if (isLoading) {
    return <Loader minHeight="50vh" />;
  }

  if (isEmpty(data)) {
    return (
      <Annunciator
        title={t('results.not.found.title', 'По вашему запросу ничего не найдено')}
        text={t('results.not.found.text', 'попробуйте поменять фильтр и попробовать снова')}
      />
    );
  }

  return (
    <Grid container {...props}>
      {items}
    </Grid>
  );
};
